import { useEffect } from 'react';
import { withStyles } from 'vopay';
import styles from './SelectOption.module.scss';

const cn = withStyles(styles);

export type SelectOptionProps = {
  id: string;
  children: React.ReactNode;
  focused: boolean;
  selected: boolean;
  disabled: boolean;
  onMouseOver: () => void;
  onSelect: () => void;
  onKeyDown?: (e: KeyboardEvent) => void;
  className?: string;
  style?: React.CSSProperties;
};

export default function SelectOption({
  id,
  children,
  focused,
  className,
  style,
  selected,
  disabled,
  onMouseOver,
  onSelect,
  onKeyDown,
}: SelectOptionProps) {
  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent) => {
      if (!focused) return;

      onKeyDown && onKeyDown(e);
    };

    document.addEventListener('keydown', handleKeydown);

    return () => document.removeEventListener('keydown', handleKeydown);
  }, [focused]);

  return (
    <li
      tabIndex={-1}
      id={id}
      className={cn('selectOption', focused && 'focused', selected && 'selected', disabled && 'disabled', className)}
      style={style}
      role="option"
      aria-selected={selected}
      aria-disabled={disabled}
      onMouseOver={onMouseOver}
      onFocus={() => {}}
      onClick={onSelect}
      onKeyDown={() => {}}
    >
      {children}
    </li>
  );
}
